import React from "react";

export function Sidebar({ children }: { children?: React.ReactNode }) {
  // Hidden on mobile — the page menu lives in the burger drawer there.
  return (
    <div className="w-60 shrink-0 border-r border-[var(--menu-sidebar-border)] bg-[var(--menu-sidebar-bg)] pt-[93px] pb-[93px] text-left text-base max-nav:hidden">
      {children}
    </div>
  );
}
